import {
  TEMPLATE_TYPES,
  WA_BUTTON_TYPES,
  WA_COMPONENT_TYPES,
  WA_HEADER_FORMATS,
} from './TemplateConstants';

/**
 * TemplateTypeDetector - identifies the type of a WhatsApp template
 */
export class TemplateTypeDetector {
  static detectWhatsAppType(template) {
    const components = template.components || [];
    const header = components.find(c => c.type === WA_COMPONENT_TYPES.HEADER);
    const buttons = components.find(c => c.type === WA_COMPONENT_TYPES.BUTTONS);

    if (header?.format === WA_HEADER_FORMATS.IMAGE)
      return TEMPLATE_TYPES.WHATSAPP_MEDIA_IMAGE;
    if (header?.format === WA_HEADER_FORMATS.VIDEO)
      return TEMPLATE_TYPES.WHATSAPP_MEDIA_VIDEO;
    if (header?.format === WA_HEADER_FORMATS.DOCUMENT)
      return TEMPLATE_TYPES.WHATSAPP_MEDIA_DOCUMENT;

    if (buttons) {
      const hasCopyCode = buttons.buttons?.some(
        b => b.type === WA_BUTTON_TYPES.COPY_CODE
      );
      if (hasCopyCode) return TEMPLATE_TYPES.WHATSAPP_COPY_CODE;
      return TEMPLATE_TYPES.WHATSAPP_INTERACTIVE;
    }

    if (header?.format === WA_HEADER_FORMATS.TEXT)
      return TEMPLATE_TYPES.WHATSAPP_TEXT_HEADER;
    return TEMPLATE_TYPES.WHATSAPP_TEXT;
  }
}
